<template>
    <div>
        <div class="panel panel-default" style="margin: 20px;">
            <div class="panel-heading"><h4 class="panel-title"><i class="fa fa-bookmark"></i>设置培训课程</h4></div>
            <div class="panel-body">
                <div class="row">
                    <form class="form-horizontal" >
                        <div class="col-sm-12">
                            <div class="col-sm-12" style="border: 1px solid #ccc;margin-top: 5px"   v-for = "(item,index) in model.commXmKcszList" :key="'combox_'+index">
                                <div class="form-group">
									<div class="col-sm-12" style="padding-top: 8px">
										<label class="col-sm-2 control-label"><span class="required">*</span>课程</label>
										<div class="col-sm-4">
											<BootstrapCombobox :formatOption="(item)=>{return item.kcdm+'-'+item.kcmc}" :data="kcList" :name="'kcid'+index"  value-field="id" text-field="kcmc" v-model="item.kcid"  data-vv-as="课程" v-validate="{required:true}"></BootstrapCombobox>
											<span class="error_validate_msg"><em>{{ errors.first('kcid'+index) }}</em></span>
										</div>
									
										<div class="col-sm-4">
											<div class="form-group">
												<div class="col-sm-5">
													<button @click="addJl()" type="button"  class="btn btn-primary btn-sm" title="添加"><i class="fa fa-plus" aria-hidden="true"></i></button>
													<button @click="delJl(d,index)" type="button" style="margin-left:5px" class="btn btn-danger btn-sm" title="删除"><i class="fa fa-times" aria-hidden="true"></i></button>
												</div>
											</div>
										</div>
									</div>
                                    <div class="col-sm-12" style="padding-top: 5px">
                                            <label class="col-sm-2 control-label"><span class="required">*</span>课时</label>
                                            <div class="col-sm-4">
                                                <input oninput = "value=value.replace(/[^\d]/g,'')" :name="'kcks_'+index" type="text" v-model="item.kcks" placeholder=""  class="form-control"  data-vv-as="课时" v-validate="{required:true}">
                                                <span class="error_validate_msg"><em>{{ errors.first('kcks_'+index) }}</em></span>
                                            </div>
                                    </div>
                                    <div class="col-sm-12" style="padding-top: 6px">
                                        <div class="col-sm-4">
                                            <label  class="col-sm-6 control-label"><span class="required">*</span>直播成绩占比</label>
                                            <div class="col-sm-6">
                                                <input type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" :name="'zbcjbl_'+index"  v-model="item.zbcjbl" v-validate="{required:true,max:50}"  data-vv-as="直播学习成绩占比" class="form-control" placeholder="0%"/>
                                                <span class="error_validate_msg"><em>{{ errors.first('zbcjbl_'+index) }}</em></span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <label  class="col-sm-6 control-label"><span class="required">*</span>课件成绩占比</label>
                                            <div class="col-sm-6">
                                                <input type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" :name="'kjxxcjbl_'+index" v-model="item.kjxxcjbl" v-validate="{required:true,max:50}"  data-vv-as="课件学习成绩占比" class="form-control" placeholder="0%"/>
                                                <span class="error_validate_msg"><em>{{ errors.first('kjxxcjbl_'+index) }}</em></span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <label  class="col-sm-6 control-label"><span class="required">*</span>面授成绩占比</label>
                                            <div class="col-sm-6">
                                                <input type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" :name="'mscjbl_'+index" v-model="item.mscjbl" v-validate="{required:true,max:50}"  data-vv-as="面授学习成绩占比" class="form-control" placeholder="0%"/>
                                                <span class="error_validate_msg"><em>{{errors.first('mscjbl_'+index)}}</em></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--保存-->
                        <div class="col-sm-12 text-center" style="margin-top: 12px">
                            <div class="form-group">
                                <button @click="save()" type="button" class="btn btn-primary btn-sm " style="margin-right:16px">保存</button>
                                <button @click="fh()" type="button" class="btn btn-primary btn-sm ">取消</button>
                            </div>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    </div>
</template>
<script>

    /**
     * 培训课程设置-设置培训课程
     */
    export default {
        name:"TrainingCourseConfigShezhi",
        components:{
        },
        data:function(){
            return {
                kcList:[],//课程
                model:{
                    xmId:'',
                    commXmKcszList:[
                        {
                            kcmc: '',
                            kcid:'',//课程
                            kcks:'',//课时
                            mscjbl:'0',//面授学习成绩占比
                            zbcjbl:'0',//直播学习成绩占比
                            kjxxcjbl:'0',//课件学习成绩占比
                        },

                    ]
                },

            }
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'职业培训'},{name:'在线培训'},{name:'培训计划'},{name:'培训课程设置'},{name:'设置培训课程'}]);
            this.$store.commit('setShowReturnBackBtn',true);
            //获取课程
            this.$http.post('/htgl/biz/zypx/pckc/hqByKc').then(res=>{
                this.kcList = res.data;
            });
            //获取
            this.$http.post('/htgl/biz/zypx/pckc/hq',{xmId:this.$route.query.xmId}).then(res=>{
                this.model.xmId = res.data.xmId;
                if(res.data.commXmKcszList){
                    this.model = res.data;
					if(this.model.commXmKcszList && this.model.commXmKcszList.length>0){
						this.model.commXmKcszList.forEach(x=>{
							x.mscjbl = x.mscjbl || '0';//面授学习成绩占比
							x.zbcjbl = x.zbcjbl || '0';//直播学习成绩占比
							x.kjxxcjbl = x.kjxxcjbl || '0';//课件学习成绩占比
							x.kcks = x.kcks || '0';//课时
						});
					}
                }

            });
        },
        methods: {
            //新增
            addJl:function(){
                this.model.commXmKcszList.push({
                    mscjbl:'0',//面授学习成绩占比
                    zbcjbl:'0',//直播学习成绩占比
                    kjxxcjbl:'0',//课件学习成绩占比
                });
            },
            //删除
            delJl:function(d,index){
                if(this.model.commXmKcszList && this.model.commXmKcszList.length > 1){
                    //从数组中删除下标为index的数据 删除1个
                    this.model.commXmKcszList.splice(index,1);
                }
            },

            //保存
            save:function(){
                this.$validator.validateAll().then((result) => {

                    if (result) {//如果表单校验通过才可以保存
                        var checkFlag =true;
                        this.model.commXmKcszList.forEach((item)=>{
                            item.kcId=item.kcid;
                            if (item.mscjbl*1+item.zbcjbl*1+item.kjxxcjbl*1!=100) {
                                this.$error("直播成绩占比+课件成绩占比+面授成绩占比必须100%");
                                checkFlag=false
                            }
                        });
                        if(checkFlag){
                            this.$http.post('/htgl/biz/zypx/pckc/xz',JSON.stringify(this.model),{'Content-Type':'application/json;charset=UTF-8'}).then(res=>{
                                if(res.data==true){
                                    this.$success('操作成功',()=>{
                                        this.$router.push({name:'TrainingCourseConfigList'})
                                    })
                                }
                            })
                        }


                    }
                })
            },
            fh:function(){
                this.$router.push({name:'TrainingCourseConfigList'});
            }
        }

    }
</script>
<style scoped>

</style>
